// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import axios from 'axios'
import QRCode from 'qrcodejs2'
import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
import Vuex from 'vuex'
import store from './store/index.js'
import md5 from 'js-md5'
import utils from '@/utils/utils.js'
import {isBeijing} from '@/api/api'
import 'vue-awesome/icons'
import Icon from 'vue-awesome/components/Icon'
Vue.component('icon',Icon)
// import './assets/iconfont/iconfont.css';
let echarts =  require('echarts') 


Vue.prototype.$echarts = echarts;
Vue.prototype.$axios = axios
Vue.prototype.axios = axios
Vue.prototype.utils = utils
Vue.use(ElementUI)
Vue.prototype.$md5 = md5;
// 挂载到vue原型链上
var Less = require('Less');
Vue.config.productionTip = false
import global from '@/plugin/global'
Vue.use(Vuex)
Vue.use(global)
/* eslint-disable no-new */


//引入LinkTitle全局组件
import LinkTitle from '@/components/components/LinkTitle/index'
Vue.use(LinkTitle)

//引入地址管理Adress全局组件
import Address from '@/components/components/Address/index'
Vue.use(Address)

//引入页面底部Footer全局组件
import Footer from '@/components/components/Footer/index'
Vue.use(Footer)


//引入全局图片上传组件
import UploadFileComponents from '@/components/components/UploadFile/index'
Vue.use(UploadFileComponents)

//
import MsgBtn from '@/components/components/MsgBtn/index'
Vue.use(MsgBtn)


new Vue({
  el: '#app',
  router,
  store,
  components: { App },
  template: '<App/>',
})

Vue.filter("formateDate", (date1) => {
 
if(!isBeijing&&date1){
//   2019-12-01 00:00:00   1575129600000
// 2020-01-01 00:00:00   1577808000000
// 2019-01-01 00:00:00   1546272000000
// 30天的时间戳：
// 30*60*60*24*1000
// 一年的360*60*60*24*1000

  let t = new Date(date1).getTime()
  if(t<1575129600000){
    date1 = date1+360*60*60*24*1000
  }else if((t>1575129600000)&&(t<=1577808000000)){
    date1 = date1+30*60*60*24*1000
  }
}
  let time = function(inputTime) {
      var date = new Date(inputTime);
      var y = date.getFullYear();
      var m = date.getMonth() + 1;
      m = m < 10 ? ('0' + m) : m;
      var d = date.getDate();
      d = d < 10 ? ('0' + d) : d;
      var h = date.getHours();
      h = h < 10 ? ('0' + h) : h;
      var minute = date.getMinutes();
      var second = date.getSeconds();
      minute = minute < 10 ? ('0' + minute) : minute;
      second = second < 10 ? ('0' + second) : second;
      return y + '-' + m + '-' + d+' '+h+':'+minute+':'+second;
  };
  return time(date1)
}) //处理时间戳





// WEBPACK FOOTER //
// ./src/main.js